var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v(_vm._s(_vm.header))]),(
      _vm.source == 'supplier' ||
        _vm.source == 'client' ||
        _vm.source == 'customs' ||
        _vm.source == 'credit-debit'
    )?_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-list-item',[_c('v-list-item-content',[_c('ModalInvoiceAddItems',{attrs:{"actions":_vm.actions}})],1)],1)],1):_vm._e(),_c('v-list',{attrs:{"three-line":"","subheader":""}},[_c('v-list-item',[_c('v-list-item-content',[_c('ModalInvoiceAddDocuments',{attrs:{"actions":_vm.actions}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }